import { DialogTag } from '@pixelgenau/ngx-dialog';

export const BatteryOverlayComponentDialogTag = new DialogTag<void, boolean>('battery-overlay-dialog', async () => {
    const { BatteryOverlayComponent } = await import('./battery-overlay.component');
    return BatteryOverlayComponent;
});
